import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Spinner } from "@phosphor-icons/react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sid = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("session_id");
    if (!sid) {
      navigate("/login", { replace: true });
      return;
    }
    api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sid, "X-Industry": localStorage.getItem("orbit_industry") || "" } })
      .then(({ data }) => {
        localStorage.removeItem("orbit_industry");
        window.history.replaceState(null, "", "/app/dashboard");
        login(data.access_token, data.user);
        navigate("/app/dashboard", { replace: true });
      })
      .catch(() => {
        navigate("/login?error=google", { replace: true });
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#FAFAFB] gap-4" data-testid="auth-callback">
      <Spinner size={40} className="animate-spin text-emerald-600" />
      <p className="text-zinc-500 text-sm">Signing you in…</p>
    </div>
  );
}
